import React, { useEffect, useState } from 'react'
import { FaMusic, FaPlus } from 'react-icons/fa'
import { useMusic } from '../context/MusicContext'
import { useParams } from 'react-router-dom'

export function BookView() {
  const {
    selectedBook,
    bookChapters,
    isBookLoading,
    setFallbackPlaylist,
    clearUserPlaylist,
    addToUserPlaylist,
    addBookChaptersToUserPlaylist,
    currentTrack,
    playSong,
    API_URL,
    handleBookSelect,
  } = useMusic()

  const { bookName } = useParams()
  const [buttonPressedKey, setButtonPressedKey] = useState(null)

  useEffect(() => {
    handleBookSelect(bookName)
    console.log('bookName', bookName)
  }, [bookName, handleBookSelect])

  const onChapterSelect = (selectedChapter, index) => {
    clearUserPlaylist()
    setFallbackPlaylist(bookChapters)
    playSong(selectedChapter, index)
  }

  return (
    <>
      <div className="book-card">
        {selectedBook && (
          <img
            src={`${API_URL}/book/${selectedBook}/cover`}
            alt={selectedBook}
            className="artist-image"
          />
        )}
        <div className="book-card-header">
          <h3>{selectedBook || bookName}</h3>
          <button
            type="button"
            className="book-add-all-chapters-btn"
            title="Lägg till alla kapitel i kön"
            disabled={!bookChapters?.length}
            onClick={() => addBookChaptersToUserPlaylist(bookChapters)}
          >
            Lägg till alla i kön
          </button>
        </div>
      </div>
      {isBookLoading && (
        <div className="page-status" role="status" aria-live="polite">
          Laddar kapitel...
        </div>
      )}
      {!isBookLoading && bookChapters.length === 0 && (
        <div className="page-status" role="status">
          Inga kapitel hittades.
        </div>
      )}
      <ul className="song-list">
        {bookChapters.map((item, index) => (
          <li
            key={item.chapter}
            className={`song-item ${
              currentTrack?.type === 'audio-book' &&
              currentTrack.creator === item.book &&
              currentTrack.title === item.chapter
                ? 'active'
                : ''
            }`}
            onClick={() => {
              onChapterSelect(item, index)
            }}
          >
            <div className="song-item-content">
              <button
                type="button"
                className={`add-to-playlist-button ${buttonPressedKey === item.chapter ? 'clicked' : ''}`}
                title="Lägg till kapitel i kön"
                aria-label="Lägg till kapitel i kön"
                onClick={(e) => {
                  e.stopPropagation()
                  addToUserPlaylist(item)
                  setButtonPressedKey(item.chapter)
                  // console.log('User clicked button "add-to-playlist-button"')
                  setTimeout(() => {
                    setButtonPressedKey(null)
                    // console.log('button is resetet to normal look')
                  }, 300)
                }}
              >
                <FaPlus size={18} />
              </button>
              <span className="fallback-icon" style={{ display: 'none' }}>
                <FaMusic size={40} />
              </span>
              <span>{item.chapter}</span>
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}
